export const REPORT_FONT_SIZE = 18;
export const BLOCK_WRAPPER_PADDING = 32;
